module.exports = __webpack_public_path__ + "static/the-other-boleyn-girl-movie-tiein-ccdb68137222a348401043aa83b1dd71.jpg";